// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Mail from "@insite/mobius/Icons/Mail";
import RefreshCcw from "@insite/mobius/Icons/RefreshCcw";
import RotateCcw from "@insite/mobius/Icons/RotateCcw";
import X from "@insite/mobius/Icons/X";
import {
    createListDetailButtonStyle,
    linkLikeButtonCss,
} from "@rpsc/App/SharedStyles/MyAccountDetailsStyles";
import { orderDetailsButtonSetStyles } from "@rpsc/Overrides/Widgets/OrderDetails/OrderDetailsButtonSet";
import Print from "@rpsc/XDL/Icons/IconPrint";
import { mergeWithCss } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

orderDetailsButtonSetStyles.printButton = {
    ...mergeWithCss(createListDetailButtonStyle(Print), linkLikeButtonCss),
};

orderDetailsButtonSetStyles.shareEntityButtonStyles = {
    button: {
        ...mergeWithCss(createListDetailButtonStyle(Mail), linkLikeButtonCss),
    },
};

orderDetailsButtonSetStyles.reorderButton = {
    ...mergeWithCss(createListDetailButtonStyle(RotateCcw), linkLikeButtonCss),
};

orderDetailsButtonSetStyles.rmaButton = {
    ...mergeWithCss(createListDetailButtonStyle(RefreshCcw), linkLikeButtonCss),
};

orderDetailsButtonSetStyles.cancelButton = {
    ...mergeWithCss(createListDetailButtonStyle(X), linkLikeButtonCss),
};

orderDetailsButtonSetStyles.spinner = {
    size: 22,
    css: css`
        margin: 8px;
    `,
};

orderDetailsButtonSetStyles.buttonsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px 24px;
    `,
};

orderDetailsButtonSetStyles.buttonWrapper = {
    css: css`
        margin: 0;
    `,
};

orderDetailsButtonSetStyles.toasterMessage = {
    css: css`
        display: flex;
        align-items: center;
        a span {
            font-size: 15px;
        }
    `,
};
